

























import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { localize } from '@/core/filters';
import { Page } from '@/core/components/controls';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events,
} from '@/core/contracts';
import LogisticsNetworkMap from './LogisticsNetworkMap.vue';
import { debounce } from 'lodash';
import config from '@/config';

@Component({
    components: {
        LogisticsNetworkMap,
    },
})
export default class LogisticsNetworkPage extends Page {
    public pageKey: string = 'logistics-network-control';
    private mapControl?: LogisticsNetworkMap;
    private visibleVehicle: boolean = true;
    private visibleChannel: boolean = true;
    private resizeDebounced = debounce(
        this.onResize.bind(this),
        config.events.mapResizeDelay
    );

    private readonly eventSubsriptions = [
        {
            eventName: Events.ProcessingFinished,
            handler: this.mounted,
        },
    ];

    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public get pageName(): string {
        return this.getPageCaption(this.pageKey);
    }

    public getPageCaption(value: string) {
        value = value.replace(new RegExp('-', 'g'), '_').toUpperCase();
        return localize(`${value}_CAPTION`);
    }

    private mounted() {
        this.mapControl = this.$refs.mapControl as LogisticsNetworkMap;
        this.subscribeEvents();
    }

    private async beforeDestroy() {
        this.unsubscribeEvents();
    }

    private resized() {
        this.resizeDebounced();
    }

    private onResize() {
        this.mapControl!.resize();
    }

    private toggleVehicle() {
        this.visibleVehicle = !this.visibleVehicle;
        this.mapControl!.toggleVehicle(this.visibleVehicle);
    }

    private toggleChannel() {
        this.visibleChannel = !this.visibleChannel;
    }

    private subscribeEvents() {
        this.eventSubsriptions.forEach(event => {
            this._eventsService!.on(event.eventName, event.handler);
        });
    }

    private unsubscribeEvents() {
        this.eventSubsriptions.forEach(subscription => {
            this._eventsService!.off(
                subscription.eventName,
                subscription.handler
            );
        });
    }
}
